'use client';

import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { isDesktop } from 'react-device-detect';
import { FeatureFlags } from '@/lib/consts/featureFlags';
import { ROUTES } from '@/lib/consts/routes';
import { shouldShowOtpButton } from '@/lib/utils/loginFlow';
import { useAuthBoot } from '../context/AuthBootContext';

export const useLoginDisplay = (): {
  showOtpButton: boolean;
  displayWebviewEscapeScreen: boolean;
  displayTermsBlock: boolean;
  isProvidersScreen: boolean;
} => {
  const { authBoot, isWebview } = useAuthBoot();
  const pathname = usePathname();
  const { otpOn, otpTextModel } = authBoot.integration.playersAuthentication;

  const showOtpButton = useMemo(
    () =>
      shouldShowOtpButton({
        otpOn,
        otpTextModel,
        mobileOnlyOtpFF: authBoot.featureFlags[FeatureFlags.WEBSTORE_MOBILE_ONLY_OTP],
        isDesktopDevice: isDesktop,
      }),
    [otpOn, otpTextModel, isWebview, authBoot, authBoot.featureFlags]
  );

  const isProvidersScreen = pathname === ROUTES.LOGIN;
  const displayWebviewEscapeScreen = isWebview && isProvidersScreen && !showOtpButton;
  const displayTermsBlock = !isWebview || showOtpButton;

  return { showOtpButton, displayWebviewEscapeScreen, displayTermsBlock, isProvidersScreen };
};
